import { QueryKey, useQuery, QueryResult, QueryConfig } from "react-query";
import { AxiosRequestConfig } from "axios";
import api from "../index";
import { ICurrencyListResponse } from "types/payments/Currency";

export const getCurrencies = async (
  options?: AxiosRequestConfig,
): Promise<ICurrencyListResponse> => {
  const { data } = await api.get<ICurrencyListResponse>(
    "/payments/currency",
    options,
  );
  return data;
};

export const getCurrenciesQueryKey = () => [`payments/currency`];

export const useCurrencies = (options?: {
  query?: QueryConfig<ICurrencyListResponse, void>;
  request?: AxiosRequestConfig;
}): QueryResult<ICurrencyListResponse, void> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options || {};
  const queryKey = queryOptions?.queryKey ?? getCurrenciesQueryKey();

  const queryFn = () => getCurrencies(requestOptions);

  const query = useQuery(queryKey, queryFn, {
    ...queryOptions,
    staleTime: 15 * 60 * 1000,
    cacheTime: 15 * 60 * 1000,
  });

  return {
    queryKey,
    ...query,
  };
};
